import { INITIAL_FIELD_VALUE } from "constants/common";
export const FLAG_PATH_SRC = "https://assets.airtel.in/static-assets/b2b-cms/flag-images/";
export const COUNTRIES = [
  { name: "Abkhazia", phone: +7840, path: "Abkhazia.png" },
  { name: "Afghanistan", phone: 93, path: "Afghanistan.png" },
  { name: "ÅlandIslands", phone: +35818, path: "ÅlandIslands.png" },
  { name: "Albania", phone: 355, path: "Albania.png" },
  { name: "Algeria", phone: 213, path: "Algeria.png" },
  { name: "American Samoa", phone: +1684, path: "AmericanSamoa.png" },
  { name: "Andorra", phone: 376, path: "Andorra.png" },
  { name: "Angola", phone: 244, path: "Angola.png" },
  { name: "Anguilla", phone: +1264, path: "Anguilla.png" },
  { name: "Antiguaand Barbuda", phone: +1268, path: "AntiguaandBarbuda.png" },
  { name: "Argentina", phone: 54, path: "Argentina.png" },
  { name: "Armenia", phone: 374, path: "Armenia.png" },
  { name: "Aruba", phone: 297, path: "Aruba.png" },
  { name: "Ascension", phone: 247, path: "Ascension.png" },
  { name: "Australia", phone: 61, path: "Australia.png" },
  { name: "Australian Antarctic Territory", phone: +6721, path: "Australia-1.png" },
  { name: "Australian External Territories", phone: 672, path: "AustralianExternalTerritories.png" },
  { name: "Austria", phone: 43, path: "Austria.png" },
  { name: "Azerbaijan", phone: 994, path: "Azerbaijan.png" },
  { name: "Bahamas", phone: +1242, path: "Bahamas.png" },
  { name: "Bahrain", phone: 973, path: "Bahrain.png" },
  { name: "Bangladesh", phone: 880, path: "Bangladesh.png" },
  { name: "Barbados", phone: +1246, path: "Barbados.png" },
  { name: "Barbuda", phone: +1268, path: "Barbuda.png" },
  { name: "Belarus", phone: 375, path: "Belarus.png" },
  { name: "Belgium", phone: 32, path: "Belgium.png" },
  { name: "Belize", phone: 501, path: "Belize.png" },
  { name: "Benin", phone: 229, path: "Benin.png" },
  { name: "Bermuda", phone: +1441, path: "Bermuda.png" },
  { name: "Bhutan", phone: 975, path: "Bhutan.png" },
  { name: "Bolivia", phone: 591, path: "Bolivia.png" },
  { name: "Bonaire", phone: +5997, path: "Bonaire.png" },
  { name: "Bosniaand Herzegovina", phone: 387, path: "BosniaandHerzegovina.png" },
  { name: "Botswana", phone: 267, path: "Botswana.png" },
  { name: "Brazil", phone: 55, path: "Brazil.png" },
  { name: "British Indian Ocean Territory", phone: 246, path: "BritishIndianOceanTerritory.png" },
  { name: "British Virgin Islands", phone: +1284, path: "BritishVirginIslands.png" },
  { name: "Brunei Darussalam", phone: 673, path: "BruneiDarussalam.png" },
  { name: "Bulgaria", phone: 359, path: "Bulgaria.png" },
  { name: "BurkinaFaso", phone: 226, path: "BurkinaFaso.png" },
  { name: "Burundi", phone: 257, path: "Burundi.png" },
  { name: "Cambodia", phone: 855, path: "Cambodia.png" },
  { name: "Cameroon", phone: 237, path: "Cameroon.png" },
  { name: "Canada", phone: 1, path: "Canada.png" },
  { name: "CapeVerde", phone: 238, path: "CapeVerde.png" },
  { name: "Caribbean Netherlands", phone: +5993, path: "CaribbeanNetherlands.png" },
  { name: "CaymanIslands", phone: +1345, path: "CaymanIslands.png" },
  { name: "Central African Republic", phone: 236, path: "CentralAfricanRepublic.png" },
  { name: "Chad", phone: 235, path: "Chad.png" },
  { name: "ChathamIsland, NewZealand", phone: 64, path: "ChathamIslandNewZealand.png" },
  { name: "Chile", phone: 56, path: "Chile.png" },
  { name: "China", phone: 86, path: "China.png" },
  { name: "Christmas Island", phone: +6189164, path: "ChristmasIsland.png" },
  { name: "Cocos(Keeling) Islands", phone: +6189162, path: "CocosKeelingIslands.png" },
  { name: "Colombia", phone: 57, path: "Colombia.png" },
  { name: "Comoros", phone: 269, path: "Comoros.png" },
  { name: "Congo", phone: 242, path: "Congo.png" },
  { name: "Congo,theDemocraticRepublicofthe(Zaire)", phone: 243, path: "Congo.png" },
  { name: "CookIslands", phone: 682, path: "CookIslands.png" },
  { name: "CostaRica", phone: 506, path: "CostaRica.png" },
  { name: "IvoryCoast", phone: 225, path: "IvoryCoast.png" },
  { name: "Croatia", phone: 385, path: "Croatia.png" },
  { name: "Cuba", phone: 53, path: "Cuba.png" },
  { name: "GuantanamoBay,Cuba", phone: +5399, path: "GuantanamoBayCuba.png" },
  { name: "CuraÃ§ao", phone: +5999, path: "CuraÃ§ao.png" },
  { name: "Cyprus", phone: 357, path: "Cyprus.png" },
  { name: "CzechRepublic", phone: 420, path: "CzechRepublic.png" },
  { name: "Denmark", phone: 45, path: "Denmark.png" },
  { name: "DiegoGarcia", phone: 246, path: "DiegoGarcia.png" },
  { name: "Djibouti", phone: 253, path: "Djibouti.png" },
  { name: "Dominica", phone: +1767, path: "Dominica.png" },
  { name: "Dominican Republic", phone: +1809, path: "DominicanRepublic.png" },
  { name: "EastTimor", phone: 670, path: "EastTimor.png" },
  { name: "EasterIsland", phone: 56, path: "EasterIsland.png" },
  { name: "Ecuador", phone: 593, path: "Ecuador.png" },
  { name: "Egypt", phone: 20, path: "Egypt.png" },
  { name: "ElSalvador", phone: 503, path: "ElSalvador.png" },
  { name: "Equatorial Guinea", phone: 240, path: "EquatorialGuinea.png" },
  { name: "Eritrea", phone: 291, path: "Eritrea.png" },
  { name: "Estonia", phone: 372, path: "Estonia.png" },
  { name: "Ethiopia", phone: 251, path: "Ethiopia.png" },
  { name: "Falkland Islands", phone: 500, path: "FalklandIslands.png" },
  { name: "Faroe Islands", phone: 298, path: "FaroeIslands.png" },
  { name: "Fiji", phone: 679, path: "Fiji.png" },
  { name: "Finland", phone: 358, path: "Finland.png" },
  { name: "France", phone: 33, path: "France.png" },
  { name: "French Antilles", phone: 596, path: "FrenchAntilles.png" },
  { name: "French Guiana", phone: 594, path: "FrenchGuiana.png" },
  { name: "French Polynesia", phone: 689, path: "FrenchPolynesia.png" },
  { name: "Gabon", phone: 241, path: "Gabon.png" },
  { name: "Gambia", phone: 220, path: "Gambia.png" },
  { name: "Georgia", phone: 995, path: "Georgia.png" },
  { name: "Germany", phone: 49, path: "Germany.png" },
  { name: "Ghana", phone: 233, path: "Ghana.png" },
  { name: "Gibraltar", phone: 350, path: "Gibraltar.png" },
  { name: "Greece", phone: 30, path: "Greece.png" },
  { name: "Greenland", phone: 299, path: "Greenland.png" },
  { name: "Grenada", phone: +1473, path: "Grenada.png" },
  { name: "Guadeloupe", phone: 590, path: "Guadeloupe.png" },
  { name: "Guam", phone: +1671, path: "Guam.png" },
  { name: "Guatemala", phone: 502, path: "Guatemala.png" },
  { name: "Guernsey", phone: +441481, path: "Guernsey.png" },
  { name: "Guinea", phone: 224, path: "Guinea.png" },
  { name: "Guinea-Bissau", phone: 245, path: "Guinea-Bissau.png" },
  { name: "Guyana", phone: 592, path: "Guyana.png" },
  { name: "Haiti", phone: 509, path: "Haiti.png" },
  { name: "Honduras", phone: 504, path: "Honduras.png" },
  { name: "HongKong", phone: 852, path: "HongKong.png" },
  { name: "Hungary", phone: 36, path: "Hungary.png" },
  { name: "Iceland", phone: 354, path: "Iceland.png" },
  { name: "India", phone: 91, path: "India.png" },
  { name: "Indonesia", phone: 62, path: "Indonesia.png" },
  { name: "Iran", phone: 98, path: "Iran.png" },
  { name: "Iraq", phone: 964, path: "Iraq.png" },
  { name: "Ireland", phone: 353, path: "Ireland.png" },
  { name: "IsleofMan", phone: +441624, path: "IsleofMan.png" },
  { name: "Israel", phone: 972, path: "Israel.png" },
  { name: "Italy", phone: 39, path: "Italy.png" },
  { name: "Jamaica", phone: +1876, path: "Jamaica.png" },
  { name: "JanMayen", phone: +4779, path: "JanMayen.png" },
  { name: "Japan", phone: 81, path: "Japan.png" },
  { name: "Jersey", phone: +441534, path: "Jersey.png" },
  { name: "Jordan", phone: 962, path: "Jordan.png" },
  { name: "Kazakhstan", phone: +76, path: "Kazakhstan.png" },
  { name: "Kenya", phone: 254, path: "Kenya.png" },
  { name: "Kiribati", phone: 686, path: "Kiribati.png" },
  { name: "Korea, North", phone: 850, path: "KoreaNorth.png" },
  { name: "Korea, South", phone: 82, path: "KoreaSouth.png" },
  { name: "Kosovo", phone: 383, path: "Kosovo.png" },
  { name: "Kuwait", phone: 965, path: "Kuwait.png" },
  { name: "Kyrgyzstan", phone: 996, path: "Kyrgyzstan.png" },
  { name: "Laos", phone: 856, path: "Laos.png" },
  { name: "Latvia", phone: 371, path: "Latvia.png" },
  { name: "Lebanon", phone: 961, path: "Lebanon.png" },
  { name: "Lesotho", phone: 266, path: "Lesotho.png" },
  { name: "Liberia", phone: 231, path: "Liberia.png" },
  { name: "Libya", phone: 218, path: "Libya.png" },
  { name: "Liechtenstein", phone: 423, path: "Liechtenstein.png" },
  { name: "Lithuania", phone: 370, path: "Lithuania.png" },
  { name: "Luxembourg", phone: 352, path: "Luxembourg.png" },
  { name: "Macau", phone: 853, path: "Macau.png" },
  { name: "Macedonia", phone: 389, path: "Macedonia.png" },
  { name: "Madagascar", phone: 261, path: "Madagascar.png" },
  { name: "Malawi", phone: 265, path: "Malawi.png" },
  { name: "Malaysia", phone: 60, path: "Malaysia.png" },
  { name: "Maldives", phone: 960, path: "Maldives.png" },
  { name: "Mali", phone: 223, path: "Mali.png" },
  { name: "Malta", phone: 356, path: "Malta.png" },
  { name: "Marshall Islands", phone: 692, path: "MarshallIslands.png" },
  { name: "Martinique", phone: 596, path: "Martinique.png" },
  { name: "Mauritania", phone: 222, path: "Mauritania.png" },
  { name: "Mauritius", phone: 230, path: "Mauritius.png" },
  { name: "Mayotte", phone: +262269, path: "Mayotte.png" },
  { name: "Mexico", phone: 52, path: "Mexico.png" },
  { name: "Micronesia, FederatedStatesof", phone: 691, path: "MicronesiaFederatedStatesofMicronesia.png" },
  { name: "MidwayIsland, USA", phone: +1808, path: "MidwayIslandUSA.png" },
  { name: "Moldova", phone: 373, path: "Moldova.png" },
  { name: "Monaco", phone: 377, path: "Monaco.png" },
  { name: "Mongolia", phone: 976, path: "Mongolia.png" },
  { name: "Montenegro", phone: 382, path: "Montenegro.png" },
  { name: "Montserrat", phone: +1664, path: "Montserrat.png" },
  { name: "Morocco", phone: 212, path: "Morocco.png" },
  { name: "Mozambique", phone: 258, path: "Mozambique.png" },
  { name: "Myanmar", phone: 95, path: "Myanmar.png" },
  { name: "Nagorno-Karabakh", phone: +37447, path: "Nagorno-Karabakh.png" },
  { name: "Namibia", phone: 264, path: "Namibia.png" },
  { name: "Nauru", phone: 674, path: "Nauru.png" },
  { name: "Nepal", phone: 977, path: "Nepal.png" },
  { name: "Netherlands", phone: 31, path: "Netherlands.png" },
  { name: "Nevis", phone: +1869, path: "Nevis.png" },
  { name: "NewCaledonia", phone: 687, path: "NewCaledonia.png" },
  { name: "NewZealand", phone: 64, path: "NewZealand.png" },
  { name: "Nicaragua", phone: 505, path: "Nicaragua.png" },
  { name: "Niger", phone: 227, path: "Niger.png" },
  { name: "Nigeria", phone: 234, path: "Nigeria.png" },
  { name: "Niue", phone: 683, path: "Niue.png" },
  { name: "Norfolk Island", phone: +6723, path: "NorfolkIsland.png" },
  { name: "Northern Cyprus", phone: +90392, path: "NorthernCyprus.png" },
  { name: "Northern Ireland", phone: +4428, path: "NorthernIreland.png" },
  { name: "Northern Mariana Islands", phone: +1670, path: "NorthernMarianaIslands.png" },
  { name: "Norway", phone: 47, path: "Norway.png" },
  { name: "Oman", phone: 968, path: "Oman.png" },
  { name: "Pakistan", phone: 92, path: "Pakistan.png" },
  { name: "Palau", phone: 680, path: "Palau.png" },
  { name: "Palestine, Stateof", phone: 970, path: "PalestineStateofPalestine.png" },
  { name: "Panama", phone: 507, path: "Panama.png" },
  { name: "Papua New Guinea", phone: 675, path: "PapuaNewGuinea.png" },
  { name: "Paraguay", phone: 595, path: "Paraguay.png" },
  { name: "Peru", phone: 51, path: "Peru.png" },
  { name: "Philippines", phone: 63, path: "Philippines.png" },
  { name: "Pitcairn Islands", phone: 64, path: "PitcairnIslands.png" },
  { name: "Poland", phone: 48, path: "Poland.png" },
  { name: "Portugal", phone: 351, path: "Portugal.png" },
  { name: "PuertoRico", phone: +1787, path: "PuertoRico.png" },
  { name: "Qatar", phone: 974, path: "Qatar.png" },
  { name: "RÃ©union", phone: 262, path: "RÃ©union.png" },
  { name: "Romania", phone: 40, path: "Romania.png" },
  { name: "Russia", phone: 7, path: "Russia.png" },
  { name: "Rwanda", phone: 250, path: "Rwanda.png" },
  { name: "Saba", phone: +5994, path: "Saba.png" },
  { name: "SaintBartheÌlemy", phone: 590, path: "SaintBartheÌlemy.png" },
  { name: "SaintHelena", phone: 290, path: "SaintHelena.png" },
  { name: "Saint Kitts and Nevis", phone: +1869, path: "SaintKittsandNevis.png" },
  { name: "SaintLucia", phone: +1758, path: "SaintLucia.png" },
  { name: "SaintMartin(France)", phone: 590, path: "SaintMartinFrance.png" },
  { name: "Saint Pierre and Miquelon", phone: 508, path: "SaintPierreandMiquelon.png" },
  { name: "Saint Vincent and the Grenadines", phone: +1784, path: "SaintVincentandtheGrenadines.png" },
  { name: "Samoa", phone: 685, path: "Samoa.png" },
  { name: "SanMarino", phone: 378, path: "SanMarino.png" },
  { name: "SÃ£oTomÃ©andPrÃ­ncipe", phone: 239, path: "SÃ£oTomÃ©andPrÃ­ncipe.png" },
  { name: "SaudiArabia", phone: 966, path: "SaudiArabia.png" },
  { name: "Senegal", phone: 221, path: "Senegal.png" },
  { name: "Serbia", phone: 381, path: "Serbia.png" },
  { name: "Seychelles", phone: 248, path: "Seychelles.png" },
  { name: "SierraLeone", phone: 232, path: "SierraLeone.png" },
  { name: "Singapore", phone: 65, path: "Singapore.png" },
  { name: "SintEustatius", phone: +5993, path: "SintEustatius.png" },
  { name: "SintMaarten (Netherlands)", phone: +1721, path: "SintMaartenNetherlands.png" },
  { name: "Slovakia", phone: 421, path: "Slovakia.png" },
  { name: "Slovenia", phone: 386, path: "Slovenia.png" },
  { name: "SolomonIslands", phone: 677, path: "SolomonIslands.png" },
  { name: "Somalia", phone: 252, path: "Somalia.png" },
  { name: "SouthAfrica", phone: 27, path: "SouthAfrica.png" },
  { name: "South Georgia and the South Sandwich Islands", phone: 500, path: "SouthGeorgiaandtheSouthSandwichIslands.png" },
  { name: "SouthOssetia", phone: +99534, path: "SouthOssetia.png" },
  { name: "SouthSudan", phone: 211, path: "SouthSudan.png" },
  { name: "Spain", phone: 34, path: "Spain.png" },
  { name: "SriLanka", phone: 94, path: "SriLanka.png" },
  { name: "Sudan", phone: 249, path: "Sudan.png" },
  { name: "Suriname", phone: 597, path: "Suriname.png" },
  { name: "Svalbard", phone: +4779, path: "Svalbard.png" },
  { name: "Swaziland", phone: 268, path: "Swaziland.png" },
  { name: "Sweden", phone: 46, path: "Sweden.png" },
  { name: "Switzerland", phone: 41, path: "Switzerland.png" },
  { name: "Syria", phone: 963, path: "Syria.png" },
  { name: "Taiwan", phone: 886, path: "Taiwan.png" },
  { name: "Tajikistan", phone: 992, path: "Tajikistan.png" },
  { name: "Tanzania", phone: 255, path: "Tanzania.png" },
  { name: "Thailand", phone: 66, path: "Thailand.png" },
  { name: "Togo", phone: 228, path: "Togo.png" },
  { name: "Tokelau", phone: 690, path: "Tokelau.png" },
  { name: "Tonga", phone: 676, path: "Tonga.png" },
  { name: "Transnistria", phone: +3732, path: "Transnistria.png" },
  { name: "Trinidad and Tobago", phone: +1868, path: "TrinidadandTobago.png" },
  { name: "Tristan da Cunha", phone: +2908, path: "TristandaCunha.png" },
  { name: "Tunisia", phone: 216, path: "Tunisia.png" },
  { name: "Turkey", phone: 90, path: "Turkey.png" },
  { name: "Turkmenistan", phone: 993, path: "Turkmenistan.png" },
  { name: "Turks and Caicos Islands", phone: +1649, path: "TurksandCaicosIslands.png" },
  { name: "Tuvalu", phone: 688, path: "Tuvalu.png" },
  { name: "Uganda", phone: 256, path: "Uganda.png" },
  { name: "Ukraine", phone: 380, path: "Ukraine.png" },
  { name: "United ArabEmirates", phone: 971, path: "UnitedArabEmirates.png" },
  { name: "United Kingdom", phone: 44, path: "UnitedKingdom.png" },
  { name: "United States", phone: 1, path: "UnitedStates.png" },
  { name: "Uruguay", phone: 598, path: "Uruguay.png" },
  { name: "US Virgin Islands", phone: +1340, path: "USVirginIslands.png" },
  { name: "Uzbekistan", phone: 998, path: "Uzbekistan.png" },
  { name: "Vanuatu", phone: 678, path: "Vanuatu.png" },
  { name: "Venezuela", phone: 58, path: "Venezuela.png" },
  { name: "Vatican CityState(HolySee)", phone: +3906698, path: "VaticanCityStateHolySee.png" },
  { name: "Vietnam", phone: 84, path: "Vietnam.png" },
  { name: "WakeIsland, USA", phone: +1808, path: "WakeIslandUSA.png" },
  { name: "Wallis and Futuna", phone: 681, path: "WallisandFutuna.png" },
  { name: "Yemen", phone: 967, path: "Yemen.png" },
  { name: "Zambia", phone: 260, path: "Zambia.png" },
  { name: "Zanzibar", phone: +25524, path: "Zanzibar.png" },
  { name: "Zimbabwe", phone: 263, path: "Zimbabwe.png" },
];
export const DEFAULT_COUNTRY = { name: "India", phone: +91, path: "India.svg" };

export const VALIDATIONS = {
  FULL_NAME: /^[A-Z a-z]{3,}$/,
  WITHOUT_NUMBERS_SPECIAL_CHARACTERS: /^[A-Za-z\s]+$/,
  COMMON_NUMBER: /^(99999999999999|88888888888888|77777777777777|66666666666666|55555555555555|44444444444444|33333333333333|22222222222222|11111111111111|00000000000000|123456789|9999999999999|8888888888888|7777777777777|6666666666666|5555555555555|4444444444444|3333333333333|2222222222222|1111111111111|0000000000000|12345678|999999999999|888888888888|777777777777|666666666666|555555555555|444444444444|333333333333|222222222222|111111111111|000000000000|1234567|99999999999|88888888888|77777777777|66666666666|55555555555|44444444444|33333333333|22222222222|11111111111|00000000000|123456|9999999999|8888888888|7777777777|6666666666|5555555555|4444444444|3333333333|2222222222|1111111111|0000000000|12345|999999999|888888888|777777777|666666666|555555555|444444444|333333333|222222222|111111111|000000000|12345|99999999|88888888|77777777|66666666|55555555|44444444|33333333|22222222|11111111|00000000|9999999|8888888|7777777|6666666|5555555|4444444|3333333|2222222|1111111|0000000|999999|888888|777777|666666|555555|444444|333333|222222|111111|000000|99999|88888|77777|66666|55555|44444|33333|22222|11111|00000)$/,
  MOBILE_NUMBER_INDIA: /^[6-9]\d{9}$/,
  MOBILE_NUMBER_OUTSIDE: /^[0-9]{4,14}$/,
  ALL_ZERO: /^[0]+$/,
  COMPANY_NAME: /^.{3,}$/,
  MIN_LENGTH: /^.{3,}$/,
  INVALID_COMPANY_NAME:/^(?!(?:Airtel|Test|Unknown|Dummy)$)[a-zA-Z0-9\-#&.\s]*$/i,
  COMPANY_EMAIL:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  COMMON_DOMAIN_EXCLUDE: /@(.*(gmail|gamil|yahoo|yahoomail|hotmail|rediffmail|rediff|dummy|airtel|mail|email).*)\./i,
};

export const INPUT_TYPES = {
  TEXT: "TEXT",
  SELECT: "SELECT",
};

export const VALIDATION_MSGS = {
  REQUIRED: "This field cannot be left blank",
  FULL_NAME: "Invalid full name, recheck and try again",
  MOBILE_NUMBER: "Invalid mobile number, recheck and try again",
  COMPANY_NAME: "Enter minimum of 3 characters",
  COMPANY_EMAIL: "Invalid email address, recheck and try again",
  DOMAIN_ERROR_MESSAGE: "This email domain is not allowed. Please use another email.",
  INVALID_COMPANY_NAME: "Invalid company name. Please use a different one.",
  MIN_LENGTH: "Enter minimum of 3 characters",
  WITHOUT_NUMBERS_SPECIAL_CHARACTERS: "Only alphabets and spaces are allowed",
};

export const INITIAL_FORM_FIELDS = {
  FULL_NAME: "fullName",
  MOBILE_NUMBER: "mobileNumber",
  COUNTRY: "country",
  COMPANY_NAME: "companyName",
  COMPANY_EMAIL: "companyEmail",
};

const { FULL_NAME, MOBILE_NUMBER, COUNTRY, COMPANY_NAME, COMPANY_EMAIL } = INITIAL_FORM_FIELDS;

export const INITIAL_FORM_DATA = {
  fullName: {
    ...INITIAL_FIELD_VALUE,
    name: FULL_NAME,
    placeholder: "Enter Name",
    required: true,

  },
  mobileNumber: {
    ...INITIAL_FIELD_VALUE,
    name: MOBILE_NUMBER,
    placeholder: "",
    required: true,
  },
  country: {
    ...INITIAL_FIELD_VALUE,
    name: COUNTRY,
    placeholder: "",
    options: COUNTRIES,
  },
  companyName: {
    ...INITIAL_FIELD_VALUE,
    name: COMPANY_NAME,
    placeholder: "Enter Company Name",
    required: true,
  },
  companyEmail: {
    ...INITIAL_FIELD_VALUE,
    name: COMPANY_EMAIL,
    placeholder: "Enter Company Email",
    required: true,
  },
};

export const SUBMIT_FORM_API_STATUS_CODE = {
  SUCCESS: "CreateLeadS-00",
  DUPLICATE: "CreateLeadE-05",
  ERROR: "CreateLeadE-04",
};

export const SIT_URL = "https://LeadTestEAI.india.airtel.itm:9443/siebel/v1.0/service/LEAD Inbound Service/CreateLead";
export const PROD_URL = "https://digi-api.airtel.in/api/b2b/lead/create";
